<nb-tabset>
    <nb-tab tabTitle="Usuario" tabIcon="person-outline" responsive style="height: 75vh;">
        <mat-list-item role="listitem" class="items">
            <div class="row" mat-line>
                <div class="col">
                  <label><strong>Usuario: </strong>{{userName}}</label>
                </div>
              </div>
            <div class="row" mat-line>
              <div class="col">
                <label><strong>Nombre y Apellido: </strong>{{nombre}} {{apellido}}</label>
              </div>
            </div>
            <div class="row" mat-line>
                  <div class="col">
                    <label><strong>Email: </strong>{{correoElectronico}}</label>
                  </div>
              </div>
              <div class="row" mat-line>
                <div class="col">
                  <label><strong>Perfil: </strong>{{perfil}}</label>
                </div>
            </div>
            <button nbButton size="tiny" style="float: left; margin-top: 5px;" class="buttontz" (click)="openDialog()">
            Reset Contraseña</button>
            <button nbButton size="tiny" style="float: left; margin-top: 5px;" class="buttontz" (click)="cancelar()">
              Cancelar</button>
          </mat-list-item>
    </nb-tab>
</nb-tabset>